import { useTranslation } from 'react-i18next'

const CoachBefore = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="coach-before-title"
      fill="none"
      {...props}
    >
      <title id="coach-before-title">{t('antagonists:coach:components:start')}</title>
      <defs>
        <clipPath id="coach-before-b">
          <path
            d="M1482.28 343.3s9.02 28.68 3.79 43.32c-5.23 14.64-17.04 21.78-17.04 32.24s6.58 35.22 4.49 55.09c-2.09 19.87-22.86 60.24-26.31 72.68-6.53 23.55-9.54 46.09-9.54 46.09s54.11 15.58 95.94 12.96c41.83-2.61 67.29-7.38 67.29-7.38s-.97-7.19-2.27-32.87c-.85-16.72-5.89-38.67-3.28-58.54 2.61-19.87 7.38-57.01 12.09-73.75 4.71-16.73-6.02-29.59-5.49-49.98s4.54-39.65 4.54-39.65l-21.95-6.67s-10.23 27.07-39.21 27.86c-33.81.91-42.59-29.34-42.59-29.34l-20.46 7.94Z"
            style={{
              fill: '#e2007a',
            }}
          />
        </clipPath>
        <style>
          {
            '.c{fill:none}.d{fill:#f8f8f8}.e{fill:#004a7c}.f{fill:#ed7925}.g{fill:#ea6343}.h{fill:#edce5c}.i{fill:#00a39a}.j{fill:#8cabbc}.k{fill:#b37b42}.l{fill:#e2007a}.m{fill:#e2a972}.n{fill:#9d3187}.o{clip-path:url(#b)}'
          }
        </style>
      </defs>
      <path
        d="M1628.7 352.85c-7.07-6.31-33.82-11.71-33.82-11.71l6.3 90.12s-3.65 36.82-4.83 48.23c-1.18 11.41 15.46 101.71 15.46 113.12 0 11.41-.39 18.5-.39 18.5l17.71 4.33s7.48-58.24 9.05-79.1c1.57-20.86-5.51-49.98-3.94-62.18s5.43-49.27 4.17-82.84c-.4-10.62-3.05-32.53-9.7-38.47ZM1487.57 342.38s-11.95 4.63-18.38 6.13c-5.57 1.3-13.47 3.71-19.38 7.32-8.48 5.18-40.69 39.49-55.25 58.08-14.55 18.58-27.68 38.7-27.04 45.97s16.89 16.5 28.9 5.27c12.01-11.23 33.07-29.23 40.56-38.99 7.49-9.75 19.29-17.16 26.96-18.46 12.46-2.12 10.63 30.62 10.63 30.62l24.03.72 50.07-44.38-61.11-52.26ZM1494.6 894.76s6.3 20.49 6.3 30.58-1.89 36.25-1.89 36.25l33.42-12.92s.32-17.02-2.84-25.22c-3.15-8.2-11.35-25.22-11.35-25.22l-23.64-3.47ZM1612.81 903.9s6.62 17.02 6.3 24.9c-.32 7.88-2.52 21.12-2.52 21.12l33.42.63s-5.04-17.02-5.67-24.27c-.63-7.25.95-21.12.95-21.12l-32.47-1.26Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1506.99 923.24c10.58-2.65 13.61-.21 15.08 4.19 1.47 4.4 1.88 6.91 1.88 6.91s3.14 2.3 4.82 0c1.68-2.3.86-8.9 2.33-8.9s4.79 11.83 6.05 19.58c1.26 7.75 3.98 19.48 2.09 21.36-1.88 1.88-10.89 4.61-10.05 8.8.84 4.19 1.47 16.75-4.19 20.52-5.65 3.77-38.12.84-40-3.56-1.88-4.4-1.05-12.77 2.93-23.04 3.98-10.26 8.8-22.41 10.68-29.11s-1.26-14.03 1.05-15.71c2.3-1.68 4.82-.42 7.33-1.05Z"
        style={{
          fill: '#f8f8f8',
        }}
      />
      <path
        d="M1494.58 952.01c-.3 0-.59-.03-.85-.11-.69-.19-1.59-.71-1.96-2.08-.3-1.1-.12-2.2.53-3.26 2.91-4.73 15.09-7.56 17.81-8.14.74-.96 3-3.34 7.62-4 3.88-.55 8.92 2.9 11.59 6.55 1.9 2.59 2.46 5.03 1.58 6.88-.61 1.29-1.38 1.99-2.32 2.16-1.64.28-3.1-1.12-4.94-2.92-1.01-.99-2.16-2.1-3.41-2.97-3.36-2.33-7.51-3-8.85-3.17-2.66 2.53-12.02 11.06-16.79 11.06Zm13.78-11.08c-4.81 1.22-12.46 3.7-14.31 6.7-.35.57-.45 1.09-.3 1.64.15.54.39.61.53.64 2.28.61 9.02-4.42 14.08-8.99Zm3.97-1.93c1.94.29 5.78 1.14 9.07 3.42 1.39.96 2.6 2.14 3.67 3.19 1.13 1.1 2.51 2.48 3.15 2.37.09-.02.4-.13.82-1.02.53-1.12.03-2.86-1.38-4.77-2.57-3.49-6.99-6.13-9.65-5.73-3.02.43-4.79 1.69-5.69 2.55Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1504.22 970.87c-.25 0-.49-.09-.69-.27-.42-.38-.45-1.03-.07-1.45.04-.04 4.05-4.56 5.85-13.37 1.82-8.93.47-15.85.45-15.92-.1-.48.16-.97.62-1.15.45-.19.98-.02 1.25.39.25.39 6.23 9.59 7.56 15.63 1.31 5.95-.93 11.62-1.03 11.86-.21.53-.81.78-1.34.57-.53-.21-.78-.81-.57-1.34.02-.05 2.09-5.33.93-10.65-.73-3.32-3.07-7.84-4.91-11.04.14 3 .04 7.23-.95 12.06-1.92 9.41-6.17 14.15-6.35 14.35-.2.22-.48.34-.76.34Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1617.33 940.16c-2.65-.45-4.45 20.7-5.48 26.89-1.03 6.19-2.94 11.44-1.74 13.16 1.2 1.72 12.38 5.67 12.72 10.49.34 4.81-3.61 11.17 2.92 15.47 6.53 4.3 14.61 5.16 28.02 4.64 13.41-.52 15.3-3.61 16.33-7.22 1.03-3.61-.34-6.88-3.61-15.47s-11.6-20.61-12.03-28.36c-.37-6.68-3.27-13.41-4.13-22.69-.24-2.59-8.94-1.72-13.06-2.06-4.13-.34-8.25 1.38-10.14 6.88-1.4 4.08-2.23 7.74-5.67 7.56s-2.94-9.08-4.13-9.28Z"
        style={{
          fill: '#f8f8f8',
        }}
      />
      <path
        d="M1630.25 966.41c-.81 0-1.57-.31-2.25-.93-.91-.82-1.35-1.9-1.25-3.11.39-4.85 9.54-11.21 11.69-12.64.56-2.24 3.35-13.01 6.21-18.15 2.02-3.63 5.51-4.6 7.94-3.68 2.3.87 3.39 3.21 2.78 5.95-1.22 5.51-12.9 15.91-14.67 17.47-.81 2.29-5.1 13.82-9.63 14.99-.28.07-.55.11-.82.11Zm7.82-13.92c-3.55 2.55-9.03 7.09-9.27 10.05-.05.58.13 1.02.57 1.42.51.46.9.43 1.18.36 2.41-.62 5.58-6.9 7.51-11.82Zm12.68-22.87c-1.45 0-3.16.9-4.3 2.96-2.22 3.99-4.48 11.89-5.52 15.77 4.31-3.95 11.61-11.24 12.43-14.95.39-1.74-.18-3.08-1.5-3.58-.34-.13-.72-.2-1.11-.2Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1653.32 967.59c-2 0-4.32-.64-6.84-2.52-6.18-4.6-7.79-10.41-8.18-12.53-.88-.12-2.79-.39-6.85-.93-6.27-.82-11.19 6.48-11.24 6.55-.32.47-.95.6-1.43.29-.47-.32-.6-.95-.29-1.42.23-.35 5.76-8.44 13.22-7.45 7 .93 7.66 1.05 7.66 1.05l.78.14.07.79c0 .07.7 6.83 7.48 11.88 6.41 4.78 11 0 11.19-.21.38-.41 1.03-.44 1.45-.05.41.39.44 1.03.06 1.45-.04.04-2.82 2.99-7.1 2.99Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1455.98 534.43s-25.36 51.48-15.47 102.37c7.36 37.86 29.06 111.48 28.53 125.21-.53 13.74 0 58.12 6.34 82.42 6.34 24.3 22.19 71.85 22.19 71.85s10.04 2.64 16.91 1.59c6.87-1.06 12.15-4.23 12.15-4.23s-1.06-39.62 1.06-63.93c2.11-24.3-9.51-56-7.92-71.32 1.59-15.32 3.7-28.53 2.64-50.19-1.06-21.66 4.23-175.41 4.23-175.41l-70.65-18.36Z"
        style={{
          fill: '#9d3187',
        }}
      />
      <path
        d="M1507.08 577.62s29.06 92.99 39.62 119.4c10.57 26.42 20.68 66.93 29.06 82.42 6.69 12.37 13.21 21.13 14.26 30.64 1.06 9.51 1.06 36.45 7.4 56 6.34 19.55 17.96 54.42 17.96 54.42s9.51 3.17 18.49 2.11c8.98-1.06 13.74-5.81 13.74-5.81s1.06-77.14-2.64-95.63c-3.7-18.49-11.09-36.45-14.26-54.42-3.17-17.96-2.64-46.49-6.34-67.63-3.7-21.13-24.83-97.21-28.53-112.01-3.7-14.79-2.11-44.38-2.11-44.38l-86.65 34.87Z"
        style={{
          fill: '#9d3187',
        }}
      />
      <path
        d="M1514.76 281.96s5.75 28.53 2.05 40.15c-4.23 13.27-46.89 27.2-46.89 27.2s4.47 49.13 6.45 48.47c1.99-.66 140.31-11.25 140.31-11.25l-4.99-39.42s-37.09-7.53-44.89-27.42c-7.79-19.89-1.08-39.51-1.08-39.51l-50.97 1.78Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1482.28 343.3s9.02 28.68 3.79 43.32c-5.23 14.64-17.04 21.78-17.04 32.24s6.58 35.22 4.49 55.09c-2.09 19.87-22.86 60.24-26.31 72.68-6.53 23.55-9.54 46.09-9.54 46.09s54.11 15.58 95.94 12.96c41.83-2.61 67.29-7.38 67.29-7.38s-.97-7.19-2.27-32.87c-.85-16.72-5.89-38.67-3.28-58.54 2.61-19.87 7.38-57.01 12.09-73.75 4.71-16.73-6.02-29.59-5.49-49.98s4.54-39.65 4.54-39.65l-21.95-6.67s-10.23 27.07-39.21 27.86c-33.81.91-42.59-29.34-42.59-29.34l-20.46 7.94Z"
        style={{
          fill: '#e2007a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#coach-before-b)',
        }}
      >
        <path
          d="M1424.94 474.33s49.68-2.86 62.94 42.16c13.84 47-15.67 74.24-15.67 74.24s53.27-6.35 55.04-71.05c1.84-67.41-81.87-95.79-81.87-95.79l-20.44 50.45Z"
          style={{
            fill: '#ea6343',
          }}
        />
        <path
          d="M1639.08 408.71s-45.74 16.27-70.3-23.35c-25.64-41.36-5.37-75.56-5.37-75.56s-48.16 20.6-32.35 83.21c16.48 65.24 102.5 69.7 102.5 69.7l5.52-54.01Z"
          style={{
            fill: 'none',
          }}
        />
      </g>
      <path
        d="M1612.63 604.15s.26 4.1-1.79 7.68-4.23 9.73-4.1 19.84c.13 10.11 4.35 31.88 4.35 31.88s4.74 1.79 5.63-2.94c.9-4.74-1.15-19.84.9-19.84s6.53 13.32 6.53 13.32-8.07 9.09-8.07 11.65c0 2.56 1.28 3.46 1.28 3.46s7.94-6.15 8.45-5.63c1.31 1.31-6.53 11.27-7.04 14.08s1.79 5.25 1.79 5.25 5.12-3.97 7.94-7.17c2.82-3.2 6.02-7.94 7.04-10.5s1.15-19.97 1.28-23.17c.13-3.2-6.91-24.84-6.66-30.22.26-5.38 1.02-12.42 1.02-12.42l-18.56 4.74ZM1447.44 519.81c-11.5-4.72-58.71-36.25-65.26-42.92-6.54-6.66-20.65-14.75-9.07-25.07 11.58-10.31 25.29-15.91 35.65-2.52 10.36 13.4 23.88 27.34 30.54 37.01 8.44 12.24 20.02 17.25 20.02 17.25l-11.88 16.24Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1449.3 522.87c6.21.62 20.74-9.28 20.74-9.28s9.79 5.05 12.91 5.69c4.77.97 5.75-3.25 5.75-3.25s-13.15-8.05-14.44-8.57c-1.29-.51-3.68-1.18-3.68-1.18s7.42-2.38 8.89-1.87c1.47.51 12.85 4.06 15.6 3.8 5.09-.49 5.71-5.07 4.98-4.87-.72.2-13.24-4.4-13.24-4.4s9.37 2.68 12.82 2.23c3.45-.45 4.18-4.17 3.89-4.84-.39-.9-19.27-4.29-19.86-6.24-.66-2.22 13.2-3.38 15.14-5.8 1.94-2.42 1.16-5.93 1.16-5.93s-15.26 2.4-17.6 3.37-19.27 15.03-22.72 17.36c-5.61 3.79-10.41-.46-10.41-.46l-11.12 14.51s6.8 9.31 11.19 9.75Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1534.33 177.91c-11.47.41-21.77 5.57-21.01 17.55.76 11.97 11.5 11.18 10.74 14.07-.69 2.63-20.03 7.16-23.99 14.52-3.96 7.36-6.79 26.89-5.38 32.55 1.42 5.66 9.06 22.36 9.06 22.36l61.14 1.98s6.51-14.72 9.06-24.62c2.55-9.91 0-23.78-4.25-30.85-4.25-7.08-23.17-14.17-22.52-16.41.8-2.78 13.62.05 12.85-18.04-.48-11.46-18.57-13.35-25.7-13.1Z"
        style={{
          fill: '#edce5c',
        }}
      />
      <path
        d="M1537.44 236.51c-14.95-1.87-21.7 8.8-28.68 13.52-6.97 4.72-3.87 13.93-5.57 15.35-1.7 1.42-3.68-5.94-7.93-4.53-4.25 1.42.66 14.36 1.93 19.49 1.27 5.17 1.53 6.8 3.89 6.87 2 .06 4.08-2.02 4.08-2.02s1.44 11.94 2.55 16.42c1.8 7.3 12.74 18.96 19.81 21.79 7.08 2.83 13.12 4.47 18.78.22 5.66-4.25 16.72-13.38 18.86-22.58 1.24-5.35.61-12.47 1.93-14.86.92-1.66 2.92-.84 4.24-1.59 2.05-1.16 1.54-6.36 2.39-10.61.85-4.25 1.37-12.12-1.06-12.73-2.12-.53-2.97 4.12-4.67 3.55-1.7-.57-.57-13.02-4.81-18.4-4.25-5.38-18.96-9.06-25.76-9.91Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1523.44 306.97c.15 1.27 5.44 5.57 13.19 5.08 7.74-.49 12.71-4.63 13-6.2s-2.58-4.92-6.89-4.53-4.74 1.88-6.5 2.18c-1.76.3-3.06-1.22-6-1.12-2.94.1-7.09 2.04-6.8 4.59Z"
        style={{
          fill: '#ed7925',
        }}
      />
      <path
        d="m1523.45 208.3.4 1.6s7.1-.94 11.96-.85c4.86.09 11.86.88 11.86.88l.25-1.66s-7.71-1.19-12.58-1.1c-4.86.09-11.9 1.13-11.9 1.13Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1529.11 269.64s-5.39-2.03-9.26-2.58c-3.87-.56-9.18 1.83-9.18 1.83l.71 2.81s6.16-1.92 8.08-1.1c2.19.93 8.95 2.6 8.95 2.6s1.01-3.76.71-3.56ZM1540.59 270.47s4.5-3.6 8-5.33c3.51-1.73 9.3-1.1 9.3-1.1l.2 2.9s-6.45.09-8.02 1.45c-1.79 1.56-7.7 5.24-7.7 5.24s-2.12-3.27-1.78-3.16Z"
        style={{
          fill: '#b37b42',
        }}
      />
      <path
        d="m1518.98 278.48-5.07-.12-.1-1.74 5.99-.14s-.66 2.02-.82 2Z"
        style={{
          fill: '#004a7c',
        }}
      />
      <path
        style={{
          fill: '#004a7c',
        }}
        d="m1519.24 276.85-4.13-3.39.95-1.44 3.87 2.93-.69 1.9z"
      />
      <path
        d="M1519.86 274.35c-1.77.58-2.62 2.18-1.99 3.89.63 1.71 2.34 2.27 3.96 1.85 1.91-.5 2.36-2.21 1.89-4.03-.33-1.29-2.03-2.3-3.85-1.7ZM1550.33 277.24l5.04-.52-.04-1.74-5.98.33s.82 1.97.98 1.93Z"
        style={{
          fill: '#004a7c',
        }}
      />
      <path
        style={{
          fill: '#004a7c',
        }}
        d="m1549.94 275.64 3.85-3.72-1.06-1.36-3.62 3.23.83 1.85z"
      />
      <path
        d="M1549.13 273.18c1.81.44 2.79 1.97 2.29 3.72-.5 1.76-2.15 2.44-3.8 2.15-1.95-.34-2.53-2.02-2.2-3.87.23-1.31 1.84-2.46 3.71-2Z"
        style={{
          fill: '#004a7c',
        }}
      />
    </svg>
  )
}

export default CoachBefore
